<template>
  <!-- 实验室安全智能体 -->
  <div class="mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center;margin-bottom: 32px;">
      <div class="text1">实验室安全智能体</div>
    </div>
    <div class="aiWrap">
      <div>
        <div class="aiAgentBox maria">
          <OssImg class="aiIcon1" src="/UIV3/aiIcon1.png" alt="" />
          <div>环境风险识别与预警</div>
          <div>
            AI
            智能体整合摄像头（计算机视觉）、气体传感器（如有毒气体、易燃易爆气体）、温湿度传感器数据，实时识别异常
          </div>
        </div>
        <div class="aiAgentBox maria">
          <OssImg class="aiIcon1" src="/UIV3/aiIcon1.png" alt="" />
          <div>危险行为与违规操作的智能识别</div>
          <div>
            基于计算机视觉和动作识别模型，AI 智能体可识别
            “人员未戴护目镜”“在非指定区域吸烟”“违规混合试剂” 等危险操作
          </div>
        </div>
      </div>
      <div style="margin: 0 2rem">
        <OssImg src="/UIV3/aiImg.png" class="aiImg" alt="" />
        <div class="aiAgentBox maria" style="align-items: center; margin-top: 2rem">
          <OssImg class="aiIcon1" src="/UIV3/aiIcon1.png" alt="" />
          <div>动态库存与自动补给</div>
          <div>
            AI 智能体通过扫码识别（对接 RFID 或条形码系统）实时追踪试剂耗材的
            “入库 - 领用 - 消耗 - 报废” 全流程，结合实验计划预测
          </div>
        </div>
      </div>
      <div>
        <div class="aiAgentBox maria" style="align-items: flex-end">
          <OssImg class="aiIcon1" src="/UIV3/aiIcon1.png" alt="" />
          <div>智能调度与预约优化</div>
          <div>
            基于用户预约需求、设备负载、实验类型（如
            “高精度实验需避开用电高峰”），AI 智能体自动生成最优预约方案
          </div>
        </div>
        <div class="aiAgentBox maria" style="align-items: flex-end">
          <OssImg class="aiIcon1" src="/UIV3/aiIcon1.png" alt="" />
          <div>动态库存与自动补给</div>
          <div>
            AI 智能体通过扫码识别（对接 RFID 或条形码系统）实时追踪试剂耗材的
            “入库 - 领用 - 消耗 - 报废” 全流程，结合实验计划预测
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- AI智慧问答 -->
  <div class="mainBox aiQuestion wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">AI智慧问答</div>
    </div>
    <div class="labinfos mainBox">
      <div class="labInfoItem">
        <OssImg class="labInfoImg" src="/UIV3/aiIcon2.png" />
        <div>专业知识图谱支撑</div>
        <div>
          内置覆盖实验室全场景的专业知识图谱，整合最新安全法规、设备操作手册、事故案例等数据，自动关联多维度知识，针对
          “高压设备故障排查” 等问题，提供系统性解决方案
        </div>
      </div>
      <div class="aiLine"></div>
      <div class="labInfoItem">
        <OssImg class="labInfoImg" src="/UIV3/aiIcon3.png" />
        <div>动态知识更新</div>
        <div>
          自动追踪安全法规修订、行业标准变化及实验室设备升级信息，实时更新知识库，确保解答内容始终符合最新要求，助力用户规避合规风险
        </div>
      </div>
      <div class="aiLine"></div>
      <div class="labInfoItem">
        <OssImg class="labInfoImg" src="/UIV3/aiIcon4.png" />
        <div>智能预案推荐</div>
        <div>
          针对火灾、危化品泄漏等突发事故咨询，依据事故类型、严重程度智能匹配最优应急预案，提供分步骤操作指引与物资调配清单
        </div>
      </div>
    </div>
  </div>

  <!-- 丰富算法，自由搭配实时预警 -->
  <div class="aiAlgorithmBg wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center; padding-top: 24px; padding-bottom: 24px">
      <div class="text1">丰富算法，自由搭配实时预警</div>
    </div>
    <div class="algorithmGrid mainBox">
      <div class="algorithmItem" v-for="(item, index) in caseList" :key="index">
        <div>{{ item.title }}</div>
        <div>
          {{ item.subTitle }}
        </div>
      </div>
    </div>
    <div style="display: flex;align-items: center;justify-content: center;">

      <CommonBtn class="maria" title="了解更多" @click.stop="navTo('/consult')" style="max-width: 5rem;margin-top: 1rem;">
      </CommonBtn>
    </div>
  </div>

  <!-- 人员路径全掌控 -->
  <div class="mainBox wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">人员路径全掌控</div>
    </div>
    <div class="pathWrap">
      <div class="pathLeft">
        <Card class="maria" width="100%" picSize="5rem" :info="item" v-for="(item, index) in pathList" :key="index">
        </Card>
      </div>
      <OssImg src="images/pdtAi2.png" class="pathImg maria" alt="" />
    </div>
  </div>

  <!-- 环境安全管理 -->
  <div class="environmentalWrap wow animate__animated animate__fadeIn">
    <div class="title" style="text-align: center">
      <div class="text1">环境安全管理</div>
    </div>
    <OssImg class="environmentalImg" src="images/pdtAi1.png" alt="" />
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import Card from "@/components/card.vue";
import { WOW } from "wowjs";
import CommonBtn from "@/components/commenBtn.vue";
import { navTo } from "@/utils/util";

onMounted(() => {
  const wow = new WOW();
  wow.init();
});
const aiQuestionTabs = ref([
  {
    label: "专业知识图谱支撑",
    icon: "images/pdtAiIcon4.png",
    title: "人脸识别",
    subTitle:
      "毫秒级精准识别、非接触式高效通行、智能权限分级管控、多维数据融合联动",
  },
  {
    label: "动态知识更新",
    icon: "images/pdtAiIcon5.png",
    title: "动态知识更新",
    subTitle:
      "自动追踪安全法规修订、行业标准变化及实验室设备升级信息，实时更新知识库，确保解答内容始终符合最新要求，助力用户规避合规风险。",
  },
  {
    label: "智能预案推荐",
    icon: "images/pdtAiIcon6.png",
    title: "智能预案推荐",
    subTitle:
      "针对火灾、危化品泄漏等突发事故咨询，依据事故类型、严重程度智能匹配最优应急预案，提供分步骤操作指引与物资调配清单。",
  },
]);
const activeTab = ref(0);

//路径全覆盖
const pathList = ref([
  {
    icon: "images/pdtAiIcon1.png",
    title: "实时定位",
    subTitle:
      "人员实时定位，精准统计在线人员定位分布及动态，便于实现人员管理。",
  },
  {
    icon: "images/pdtAiIcon2.png",
    title: "视频联动",
    subTitle:
      "高速视频联动，针对区域内进行视频跟随，随时随地观察每个区域的现场情况，方便进行实时管理。",
  },
  {
    icon: "images/pdtAiIcon3.png",
    title: "电子围栏",
    subTitle:
      "设定电子围栏，实现区域内进入权限管理，确保有权限人员才能进入相关区域，无权限人员进入电子围栏则进行警告并产生预警推送。",
  },
]);

//丰富算法案例
const caseList = [
  {
    img: "images/pdtAi3.png",
    title: "操作异常预警",
    subTitle:
      "一旦出现违规操作，如未按流程取用危化品、设备超负载运行、未穿戴防护装备进入危险区域等，AI 能够瞬间识别异常，并依据预设的安全阈值，判断风险等级。",
  },
  {
    img: "images/pdtAi4.png",
    title: "温度火点异常",
    subTitle:
      "精准识别设备异常升温、局部过热等潜在火险，还可利用图像识别技术捕捉明火、烟雾等火灾初期特征。",
  },
  {
    img: "images/pdtAi5.png",
    title: "长时间倒地",
    subTitle:
      "托计算机视觉、姿态识别算法与深度学习技术，精准识别并响应人员突发倒地状况。向实验室安全员、医护人员及管理人员发送警报，详细说明倒地人员位置、事件发生时间等信息",
  },
  {
    img: "images/pdtAi6.png",
    title: "非合规穿戴进入",
    subTitle:
      "基于实验室安全规范及行业标准，构建涵盖防护服、护目镜、口罩、手套、安全鞋等防护装备的完整识别模型。并依据预设的安全阈值，判断风险等级。",
  },
  {
    img: "images/pdtAi7.png",
    title: "特殊实验单人在岗",
    subTitle:
      "依托多传感器与深度学习，实时监测人员数量及活动。一旦发现单人操作双人实验，或人员脱岗，立即判定异常，启动声光警报、多端预警，并联动门禁、设备管控，还留存数据助力安全复盘，保障实验全程安全。",
  },
  {
    img: "images/pdtAi8.png",
    title: "违规饮食",
    subTitle:
      "当人员在实验区内出现取食、饮水、咀嚼等饮食行为时，系统瞬间分析动作姿态、物体形态（如餐具、食物）等特征，与预设违规行为库进行比对，快速判定是否存在违规饮食情况。",
  },
];
</script>

<style lang="scss" scoped>
.aiWrap {
  width: 100%;
  display: flex;

  .aiImg {
    width: 24.875rem;
    height: 21.4375rem;
  }

  .aiAgentBox {
    width: 100%;
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    padding-top: 38px;
    box-sizing: border-box;
    margin-bottom: 2rem;
    display: flex;
    flex-direction: column;

    .aiIcon1 {
      width: 3rem;
      height: 3rem;
      margin-right: 1rem;
    }

    >div:first-of-type {
      font-weight: bold;
      font-size: 1rem;
      color: #424242;
      margin-bottom: 0.5rem;
    }

    >div:nth-of-type(2) {
      font-weight: 500;
      font-size: 0.875rem;
      color: #888888;
      text-indent: 2em;
      text-align: justify;
    }
  }
}

.aiQuestion {
  .labinfos {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 1.5rem;

    .aiLine {
      width: 2px;
      height: 148px;
      background: #32a89e;
      margin: 0 40px;
    }

    .labInfoItem {
      flex: 1;
      box-sizing: border-box;

      >div:nth-of-type(2) {
        font-weight: bold;
        font-size: 1rem;
        color: #424242;
        margin-bottom: 0.5rem;
      }

      >div:nth-of-type(3) {
        font-weight: 500;
        font-size: 0.875rem;
        color: #888888;
        text-indent: 2em;
        text-align: justify;
      }
    }

    .labInfoImg {
      width: 3rem;
      height: 3rem;
      margin-bottom: 1rem;
    }
  }

  .aiQuestionTabs {
    display: flex;
    justify-content: center;
    margin-bottom: 1.5rem;
    cursor: pointer;

    .active {
      background: #32a89e;
      color: #fff;
    }

    div {
      width: 10.0625rem;
      height: 3rem;
      text-align: center;
      line-height: 3rem;
      color: #424242;
      font-weight: 500;
      font-size: 1rem;
      margin-right: 1.5rem;
      background: #fff;
      border-radius: 0.5rem;
      cursor: pointer;

      &:last-child {
        margin-right: 0;
      }
    }
  }
}

.aiAlgorithmBg {
  width: 100%;
  background-image: url("@/assets/images/bg/aiBg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: 56px;
}

.algorithmGrid {
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  .algorithmItem {
    flex: 1;
    width: 100%;
    height: 14.375rem;
    padding: 3.625rem 1rem 0;
    box-sizing: border-box;
    border-right: 1px solid #bbbbbb;

    >div:first-child {
      color: #424242;
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.375rem;
      margin-bottom: 0.5rem;
    }

    >div:nth-child(2) {
      color: #888888;
      font-weight: 500;
      font-size: 0.875rem;
      line-height: 1.25rem;
      text-indent: 2em;
    }

    &:nth-child(3n) {
      border-right: none !important;
    }

    &:nth-child(n+4) {
      border-top: 1px solid #bbbbbb;
    }

  }
}

.pathWrap {
  width: 100%;
  display: flex;

  .pathLeft,
  .pathImg {
    width: calc(50% - 0.75rem);
  }

  .pathLeft {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    gap: 0.625rem;
  }

  .pathImg {
    margin-left: 1.5rem;
    border-radius: 1rem;
    object-fit: cover;
    min-width: 31.25rem;
  }
}

.environmentalWrap {
  width: 100%;
  position: relative;
  margin-top: 3.5rem;

  .title {
    position: absolute;
    z-index: 2;
    left: 50%;
    transform: translateX(-50%);
    top: 1rem;
    margin-top: 0;
  }

  .title>.text1 {
    color: #fff;
  }

  .environmentalImg {
    width: 100%;
    display: block;
  }
}

// @media(max-width: 768px) {
//   ::v-deep .cardBox {
//     width: 100% !important;
//   }

//   .algorithmGrid {
//     grid-template-columns: repeat(2, 1fr);
//   }

//   .pathWrap {
//     flex-direction: column;

//     .pathLeft {
//       width: 100%;
//     }

//     .pathImg {
//       margin: 0;
//       min-width: 100%;
//       margin-top: 1rem;
//     }
//   }

// }</style>
